import React, { useState } from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, StatusBadge, EmptyState } from "@/components/lux";
import { money } from "@/lib/api";
import { Receipt } from "lucide-react";

const TYPES = ["all", "direct_referral", "binary_matching", "instant_reward", "daily_salary", "self_performance", "activation", "deposit"];

export default function Transactions() {
  const [type, setType] = useState("all");
  const { data, loading } = useFetch(`/user/transactions${type !== "all" ? `?type=${type}` : ""}`, [type]);
  return (
    <div className="space-y-6">
      <PageTitle title="Transactions" subtitle="Complete history of your account activity" />
      <div className="flex flex-wrap gap-2">
        {TYPES.map((t) => (
          <button key={t} onClick={() => setType(t)} className={`btn3d ${type === t ? "btn3d-gold" : "btn3d-dark"} px-3 py-1.5 text-xs capitalize`} data-testid={`tx-filter-${t}`}>
            {t.replace(/_/g, " ")}
          </button>
        ))}
      </div>
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.transactions?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">TX ID</th><th className="py-3">Type</th><th className="py-3">Description</th><th className="py-3">Status</th><th className="py-3">Date</th><th className="py-3 text-right">Amount</th></tr></thead>
              <tbody>
                {data.transactions.map((t, i) => (
                  <tr key={i} className="row-hover border-b border-white/5">
                    <td className="py-3 text-white">{t.tx_id}</td>
                    <td className="py-3 capitalize text-[var(--text-dim)]">{t.type?.replace(/_/g, " ")}</td>
                    <td className="py-3 text-[var(--text-dim)]">{t.description}</td>
                    <td className="py-3"><StatusBadge status={t.status} /></td>
                    <td className="py-3 text-[var(--text-dim)]">{(t.created_at || "").slice(0, 10)}</td>
                    <td className={`py-3 text-right font-medium ${t.direction === "debit" ? "text-rose-300" : "gold-text"}`}>{t.direction === "debit" ? "-" : "+"}${money(t.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Receipt} title="No transactions" />}
      </GlassCard>
    </div>
  );
}
